import React from 'react';
import AppTextArea from '@/components/atoms/AppTextArea';
import AppFormLabel from '@/components/atoms/AppFormLabel';

interface Props {
  summary: string;
}

/**
 * 保険証情報（摘要）section — summary-row layout matching legacy A2.
 * Label left, readonly textarea right.
 */
const VisitClinicInsuranceSection: React.FC<Props> = ({ summary }) => {
  return (
    <div className="flex items-start gap-2 py-1">
      <AppFormLabel
        label={
          <>
            保険証情報<br />摘要欄内容
          </>
        }
        className="min-w-[6rem]"
      />
      <AppTextArea
        className="flex-1"
        value={summary}
        readOnly
      />
    </div>
  );
};

export default VisitClinicInsuranceSection;
